import React from "react";
import { useNavigate } from "react-router-dom";
import { FaBan } from "react-icons/fa6";
import { formatPhoneNumber, formatValue } from "../../utils/Utils.js";

function CustomersTableItem(props) {
  const { customer } = props;
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/crm/people/${customer.email || customer.mobile}`);
  };

  return (
    <tr
      className="cursor-pointer hover:bg-slate-50 dark:hover:bg-slate-700"
      onClick={handleRowClick}
    >
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
        <div className="flex items-center" onClick={(e) => e.stopPropagation()}>
          <label className="inline-flex">
            <span className="sr-only">Select</span>
            <input
              id={props.id}
              className="form-checkbox"
              type="checkbox"
              onChange={props.handleClick}
              checked={props.isChecked}
            />
          </label>
        </div>
      </td>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">
        <div className="flex items-center relative">
          {/*<button>*/}
          {/*  <svg*/}
          {/*    className={`w-4 h-4 shrink-0 fill-current ${props.fav ? 'text-amber-500' : 'text-slate-300 dark:text-slate-600'}`}*/}
          {/*    viewBox="0 0 16 16"*/}
          {/*  >*/}
          {/*    <path d="M8 0L6 5.934H0l4.89 3.954L2.968 16 8 12.223 13.032 16 11.11 9.888 16 5.934h-6L8 0z" />*/}
          {/*  </svg>*/}
          {/*</button>*/}
        </div>
      </td>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <div className="flex items-center">
          {/*<div className="w-10 h-10 shrink-0 mr-2 sm:mr-3">*/}
          {/*  <img className="rounded-full" src={props.image} width="40" height="40" alt={props.name} />*/}
          {/*</div>*/}
          {customer.banned && (
            <FaBan
              className="w-4 h-4 mr-1 text-red-500"
              title="Banned Customer"
            />
          )}
          <div className="font-medium text-slate-800 dark:text-slate-100">
            {customer.first_name} {customer.last_name}
          </div>
        </div>
      </td>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <div className="text-left">{customer.email}</div>
      </td>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <div className="text-left">{formatPhoneNumber(customer.mobile)}</div>
      </td>
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <div className="text-left">{customer.order_count}</div>
      </td>
      {/*<td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">*/}
      {/*  <div className="text-left font-medium text-sky-500">{props.lastOrder}</div>*/}
      {/*</td>*/}
      <td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap">
        <div className="text-left font-medium text-emerald-500">
          {formatValue(customer.total_spent)}
        </div>
      </td>
      {/*<td className="px-2 first:pl-5 last:pr-5 py-3 whitespace-nowrap w-px">*/}
      {/*  /!* Menu button *!/*/}
      {/*  <button*/}
      {/*    className="text-slate-400 hover:text-slate-500 dark:text-slate-500 dark:hover:text-slate-400 rounded-full">*/}
      {/*    <span className="sr-only">Menu</span>*/}
      {/*    <svg className="w-8 h-8 fill-current" viewBox="0 0 32 32">*/}
      {/*      <circle cx="16" cy="16" r="2"/>*/}
      {/*      <circle cx="10" cy="16" r="2"/>*/}
      {/*      <circle cx="22" cy="16" r="2"/>*/}
      {/*    </svg>*/}
      {/*  </button>*/}
      {/*</td>*/}
    </tr>
  );
}

export default CustomersTableItem;
